// Mantine modal registry.
//
// Old pages still use the Mantine modals provider to open dialogs (staff
// edit, shift edit, holiday review, etc.). New pages use custom
// tokens-styled modals in-line instead. This file keeps the old wiring
// alive during the migration so lazy-loaded old screens don't blow up.
//
// Anything that lived inside the rebuilt TMA screens (HolidayEditModal,
// SickDayEditModal) is no longer needed — the new screens don't open
// Mantine modals, so the keys are simply omitted.

import WarningModal from '../components/WarningModal';
import { ShiftEditModal } from '../components/ShiftEditModal';
import HolidayRequestModal from '../components/HolidayRequestModal';
import UpwModal from '../components/UpwModal';

const modals = {
  warningModal:        WarningModal,
  shiftEditModal:      ShiftEditModal,
  holidayRequestModal: HolidayRequestModal,
  upwModal:            UpwModal,
};

export default modals;
